import React, {Component, ReactNode} from 'react'
import {createResidentPage, ResidentPagePropsSet} from '../shared/hoc/createResidentPage'
import EventEmitterExResident from '../shared/pageBaseComponents/EventEmitterExResident'
import styled from 'styled-components'
import RMRWaitingConfirmationComponent from './ResidentMyReservationsComponents/RMRWaitingConfirmationComponent'
import RMRReservationStatusesComponent from './ResidentMyReservationsComponents/RMRReservationStatusesComponent'
import ReservationsRepository from './ReservationsRepository'
import NatCurrentDateTimeRepo
    from '../../__NoAutomatedTests/components/currentDateTime/repository/NatCurrentDateTimeRepo'
import {PlainBackLink} from '../../styledComponents/Links'
import {BlockSpacer} from '../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop, DisplayItemTitle} from '../../styledComponents/DisplayItem'
import {StyledPageTitle, ViewOnlyModeMessage} from './components/CommonStyle'
import {judgeFacilityReserveEditAuthority} from './helpers/helpers'
import {Messages} from '../../Messages'
import {withScrollToTop} from '../shared/hoc/withScrollToTop'
import {ResidentScrollBoundary} from '../../styledComponents/Constants'

interface Props {
    condominiumCd: string
    reservationsRepo: ReservationsRepository
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExResident
}

interface State {
    viewOnlyMode: boolean
}

class ResidentMyReservationsPage extends Component<Props & ResidentPagePropsSet, State> {

    constructor(props: Readonly<Props & ResidentPagePropsSet>) {
        super(props)

        this.state = {
            viewOnlyMode: false,
        }
    }

    componentDidMount(): void {
        let viewMode: boolean = false
        try {
            viewMode = !judgeFacilityReserveEditAuthority()
        } catch (e) {
            this.props.navigate(`/resident/error`, {state: {message: Messages.ESYCC0025.toString()}})
            return
        }
        this.setState({
            viewOnlyMode: viewMode,
        })
    }

    render(): ReactNode {
        return <>
            <PlainBackLink to={`/resident/condominiums/${this.props.condominiumCd}/reserve-facility-top`}>
                施設予約
            </PlainBackLink>
            <BlockSpacer height={'16px'}/>
            <DisplayItemDividerForPageTop/>
            <BlockSpacer height={'30px'}/>
            <PageTitle>
                あなたの予約一覧
            </PageTitle>
            {
                this.state.viewOnlyMode && <>
                    <BlockSpacer height={'15px'}/>
                    <ViewOnlyModeMessage>{Messages.IRESR0008.toString()}</ViewOnlyModeMessage>
                </>
            }
            <RMRWaitingConfirmationComponent
                condominiumCd={this.props.condominiumCd}
                reservationsRepo={this.props.reservationsRepo}
                eventEmitter={this.props.eventEmitter}
                navigate={this.props.navigate}
            />
            <BlockSpacer height={'30px'}/>
            <DisplayItemTitle>
                予約状況
            </DisplayItemTitle>
            <BlockSpacer height={'20px'}/>
            <ContentBody>
                <RMRReservationStatusesComponent
                    condominiumCd={this.props.condominiumCd}
                    reservationsRepo={this.props.reservationsRepo}
                    currentDateTimeRepo={this.props.currentDateTimeRepo}
                    eventEmitter={this.props.eventEmitter}
                    navigate={this.props.navigate}
                />
            </ContentBody>
        </>
    }
}

export default createResidentPage(withScrollToTop(ResidentMyReservationsPage, ResidentScrollBoundary))

const PageTitle = styled(StyledPageTitle)`
  line-height: 1;
`

const ContentBody = styled.div`
  max-width: 738px;
  margin: auto;
`
